import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

import { getGridItemWidth } from '@/utils/gridItemWidth';

export const styles = StyleSheet.create((colors, rt) => ({
  container: {
    flex: 1,
  },

  scrollViewContentContainer: {
    paddingTop: theme.spacing[5],
  },
  viewOrderBarPadding: {
    paddingBottom: 80,
  },

  selectedSection: {
    marginTop: theme.spacing[4],
    marginBottom: theme.spacing[6],
    borderRadius: theme.borderRadius.l,
    paddingHorizontal: theme.spacing[5],
  },

  additionalServicesTitle: {
    marginBottom: theme.spacing[6],
    paddingHorizontal: theme.spacing[5],
  },

  categorySection: {
    marginBottom: theme.spacing[6],
    paddingHorizontal: theme.spacing[5],
  },

  gridSection: {
    flex: 1,
  },

  // Grid layout
  servicesGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: theme.spacing[4],
    paddingHorizontal: theme.spacing[5],
    paddingBottom: rt.insets.bottom + theme.spacing[4],
  },

  gridItem: (numColumns: number) => {
    const itemAspectRatio = 4 / 3;
    const width = getGridItemWidth({
      screenWidth: Math.min(theme.breakpoints.tablet, rt.screen.width),
      horizontalPadding: theme.spacing[5] * 2,
      gap: theme.spacing[4],
      numColumns,
    });

    return {
      width: width,
      minHeight: (width * itemAspectRatio) / 2,
      aspectRatio: itemAspectRatio,
      _web: {
        height: (width * itemAspectRatio) / 2,
      },
    };
  },

  loadingGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: theme.spacing[3],
    justifyContent: 'space-between',
  },

  emptyStateContainer: {
    flex: 1,
    gap: theme.spacing[5],
    justifyContent: 'center',
    alignItems: 'center',
    // paddingHorizontal: theme.spacing[6],
    paddingVertical: theme.spacing[8],
  },

  emptyStateIcon: {
    marginBottom: theme.spacing[6],
    opacity: 0.6,
  },

  emptyStateTitle: {
    textAlign: 'center',
    marginBottom: theme.spacing[3],
    color: colors.textPrimary,
  },

  emptyStateMessage: {
    textAlign: 'center',
    color: colors.textSecondary,
    lineHeight: 22,
  },

  errorContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: theme.spacing[6],
    paddingVertical: theme.spacing[8],
  },

  errorIcon: {
    marginBottom: theme.spacing[6],
    opacity: 0.6,
  },

  errorTitle: {
    textAlign: 'center',
    marginBottom: theme.spacing[3],
    color: colors.textNegative,
  },

  errorMessage: {
    textAlign: 'center',
    color: colors.textSecondary,
    lineHeight: 22,
  },
}));
